<template>
    <div class="funds-transfer" v-if="loading">
        <div class="row align-items-center funds-transfer__tit-page tit_page">
            <div class="col-12 col-md-6 col-lg-8">
                <h1>Transferência</h1>
            </div>
            <div class="col-12  col-md-6 col-lg-4">
                <div class="back back-hide float-md-right">
                    <router-link v-if="step === 1" to="/investimentos/carteira-investimento" title="Voltar"><i>&nbsp;</i> voltar</router-link>
                    <a v-else @click="backStep()" title="voltar"><i>&nbsp;</i> voltar</a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-4 col-lg-4">
                <div class="funds-transfer__infos box-border" v-if="loading">
                    <div class="funds-transfer__infos--cash">
                        <label>Valor disponível para saque</label>
                        <span>R$ {{ Saldo == 0 ? formatCurrency(Saldo) : formatCurrency(Math.floor(Saldo * 100) / 100) }}</span>
                    </div>
                    <hr class="divier">
                    <div class="funds-transfer__infos--account">
                        <label>Nome do banco</label>
                        <span>{{nomeBanco()}}</span>
                    </div>
                    <div class="funds-transfer__infos--account">
                        <label>Tipo de conta</label>
                        <span>{{tipoConta(this.dadosBanco.DadosBancarios.TipoConta)}}</span>
                    </div>
                    <div class="funds-transfer__infos--account">
                        <label for="">Agencia</label>
                        <span>{{this.dadosBanco.DadosBancarios.Agencia}}</span>
                    </div>
                    <div class="funds-transfer__infos--account">
                        <label for="">Número da conta</label>
                        <span>{{this.dadosBanco.DadosBancarios.Conta}}</span>
                    </div>
                    <hr class="divier">
                    <div class="funds-transfer__infos--link">
                        <router-link to="/investimentos/perfil/editar-perfil?to=bank" title="Alterar conta bancária"><i class="ico-inst"></i> Alterar conta bancária</router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-8 col-lg-8">
                <div class="funds-transfer__actions box-border">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-6 col-lg-6 col-xl-5">
                            <form action="" v-if="step === 1">
                                <!-- informar valor de saque -->
                                <fieldset>
                                    <h2>Qual o valor que deseja sacar?</h2>
                                    <label for="valor">Digite quanto você quer transferir:</label>
                                    <input type="tel" class="form-control form-control-lg" placeholder="R$ 00,00" v-model="valueSaqueDate" v-mask="'money'">
                                    <p class="small">
                                        Saldo disponível para transferência: <strong>R$ {{ Saldo == 0 ? formatCurrency(Saldo) : formatCurrency(Math.floor(Saldo * 100) / 100) }}</strong><br>
                                        Não há custo para sua transferência, a operação será finalizada em até 3 dias uteis: <strong >R$ 0,00</strong>
                                    </p>
                                    <button class="btn btn-primary btn-lg btn-block" :disabled="!isValidValue()" @click="validateValue">Próximo</button>
                                    <!-- OBSERVAÇÃO: os botões ficam desativados, é ativado a partir do momento do preechimento do campo. -->
                                </fieldset>
                            </form>

                            <form v-else-if="step === 2">
                                <!-- informar data de transferência -->
                                <fieldset>
                                    <h2>Transferir quando?</h2>
                                    <datetime placeholder="__/__/____" v-model="dataText" :min-datetime="mindate" class="theme-iouu" input-class="form-control form-control-lg" type="text" format="dd/MM/yyyy"></datetime>
                                    <!-- <input class="form-control form-control-lg" v-model="transferDate" v-mask="'date'" type="text" placeholder="__/__/____" title="dd/mm/yyyy" required pattern="\d{2}/\d{2}/\d{4}"/> -->
                                    <p class="small">
                                        As transferências serão efetivas em até dois dias úteis da data de solicitação.
                                        <!--Transferências solicitadas em finais de semana, feriados nacionais ou fora de horário limite serão agendadas para o próximo dia útil e efetivada em até dois dias úteis--></p>
                                    <button class="btn btn-primary btn-lg btn-block" :disabled="!isValidDate()" @click="validateDate">Próximo</button>
                                    <!-- OBSERVAÇÃO: os botões ficam desativados, é ativado a partir do momento do preechimento do campo. -->
                                </fieldset>
                            </form>

                            <form v-else-if="step === 3">
                                <!-- confirmar transferência -->
                                <fieldset>
                                    <h2>Confirmar transferência</h2>
                                    <span class="label">Transferir em {{formatDate(dataText)}}</span>
                                    <div>
                                        <p>
                                            <strong>Valor solicitado</strong>
                                            <span class="text-secondary">R$ {{formatCurrency(formatReal(this.valueSaqueDate))}}</span>
                                        </p>
                                        <p>
                                            <strong>Custo de transferência</strong>
                                            <span class="text-danger">R$ {{formatCurrency(this.ted)}}</span>
                                        </p>
                                        <p>
                                            <strong>Valor total da transferência</strong>
                                            <span class="text-primary">R$ {{calcTotalTransfer(this.valueSaqueDate)}}</span>
                                        </p>
                                    </div>
                                    <p class="small">
                                        Transferência para o Banco: {{nomeBanco()}}<br>
                                        Agência: {{this.dadosBanco.DadosBancarios.Agencia}} - {{tipoConta(this.dadosBanco.DadosBancarios.TipoConta)}} : {{this.dadosBanco.DadosBancarios.Conta}}
                                    </p>
                                    <button class="btn btn-primary btn-lg btn-block" @click="confirmTransfer">Sim, transferir</button>
                                    <router-link to="/investimentos/carteira-investimento" class="btn btn-link">Cancelar</router-link>

                                    <!-- OBSERVAÇÃO: o fica ativo nesta etapa. -->
                                </fieldset>
                            </form>

                            <form v-else-if="step === 4">
                                <!-- autorizar transferência através de senha -->
                                <fieldset>
                                    <h2>{{this.investor.NomeCompleto}}, falta só mais um passo!</h2>
                                    <label for="senha">Por favor insira sua senha no campo abaixo para finalizar seu pedido de transferência.</label>
                                    <password-field v-model="password"/>
                                    <button class="btn btn-primary btn-lg btn-block" :class="{'btn-loading' : isLoading}" :disabled="!password || isLoading" @click="validatePassword">
                                        <span v-if="isLoading">Loading</span>
                                        <span v-else>Autorizar</span>
                                    </button>
                                    <router-link to="/investimentos/carteira-investimento" class="btn btn-link">Cancelar</router-link>
                                    <!-- OBSERVAÇÃO: os botões ficam desativados, é ativado a partir do momento do preechimento do campo. -->
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import WalletService from '../services/api/wallet/index.js';

import PasswordField from '@/components/PasswordField'
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'
import { DateTime as LuxonDateTime } from 'luxon'

    export default {
         data () {
            return {
                Saldo: 0,
                mindate: LuxonDateTime.local().toISO(),
                dataText: LuxonDateTime.local().toISO(),
                tentativas: 0,
                step: 1,
                enabled: false,
                loading: false,
                bank: null,
                bankRender: false,
                valueSaque: "",
                userId: "",
                ted: "0,00",
                password: null,
                dateSaque: new Date(),
                dateModel: null,
                Pendente: 0,
                PorcentagemRetorno:0,
                isLoading:false,
                InvTotal:0,
                RendimentoTotal:0,
                IdInvestidor:0,
                Infos:{},
                renderizou:false,
                legendMarkup:"",
                DadosLegenda:[],
                Credito: 0,
                Debito: 0,
                dadoSaldo: {},
                dadosBanco: {}
            }
        },
        components: {
          PasswordField
        },
        methods: {
            nomeBanco() {
                if(this.bank != null)
                    return this.bank.length > 0 ? this.bank[0].nome : `Outro - Codigo do banco: ${this.dadosBanco.DadosBancarios.CodigoBanco}`

                return ""            
            },
            tipoConta(conta) {
                return conta == 1 ? "Conta Corrente" : "Conta Poupança"
            },
            formatCurrency(value) {
                if(value != null){

                    if(typeof value  == "string")
                        value = parseFloat(value)

                    return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
                }

                return 0;
            },
            formatReal(num) {
                let real;
                real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
                return real;
            },
            formatDate(date) {
                let aux = date.split("T");
                let formDate = aux[0].split("-");

                return `${formDate[2]}/${formDate[1]}/${formDate[0]}`
            },
            isValidValue() {
                return this.valueSaqueDate != '';
            },
            
            // Requisição para trazer saldo atualizado
            async saldoAtualizado() {
                const { data } = await WalletService.GetSaldoWallet();

                console.log("data -> ", data);

                this.dadoSaldo = data;
                this.Saldo = data.Saldo;
                this.userId = data.UserId
            },

            async dadosBancarios(userId){
                const { data } = await WalletService.GetDadosBancariosWallet(userId)

                console.log("dados -> ", data);

                this.dadosBanco = data;

                if(this.dadosBanco.DadosBancarios.CodigoBanco) {

                    ApiClient.getWalletBank(this.dadosBanco.DadosBancarios.CodigoBanco)
                    .then(response => {

                        console.log("bank -> ", response.data);
                        this.bank = response.data;
                        this.loading = true
                    })
                } else {
                    this.loading = true;
                }
            },

            PMT(rate, periods, present, future, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Initialize future
              future = 0;

              // Evaluate rate (TODO: replace with secure expression evaluator)
              rate = eval(rate);

              // Return payment
              var result;
              if (rate === 0) {
                result = (present + future) / periods;
              } else {
                var term = Math.pow(1 + rate, periods);
              if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
              } else {
                result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
              }

              // result = Math.round(result * 100) / 100;

              return -result;
            },
            async backStep() {
                this.step = this.step - 1;

                await this.saldoAtualizado();
                await this.dadosBancarios(this.userId);
            },
            validateValue(e) {
                e.preventDefault()

                let value = this.formatReal(this.valueSaque);

                if(value < 2) {
                    this.$Notify.error('O valor da transferência não pode ser inferior a R$ 2,00');
                }
                else if(value > parseFloat(Math.floor(this.Saldo * 100) / 100)) {
                    this.$Notify.error('O valor solicitado é superior ao disponível para saque');
                } else {    
                    this.step = 2;
                }

            },
            isValidDate(){
                return this.transferDate != '';
            },
            validateDate(e) {
                e.preventDefault()

                let aux = this.dataText.split("T");
                let spliter = aux[0].split('-');
                let year = this.dateSaque.getFullYear();
				        let month = this.dateSaque.getMonth();
                let day = this.dateSaque.getDate();

                if(parseInt(spliter[2]) < day && spliter[1] < month && parseInt(spliter[0]) < year) {
        					this.$Notify.error('Data inválida, favor selecionar uma data válida');
        				} else {
                    this.step = 3
                }
            },
            confirmTransfer(e) {
                e.preventDefault()

                this.step = 4;
            },
            calcTotalTransfer(value) {
                let total = this.formatReal(value) - this.formatReal(this.ted)

                return this.formatCurrency(total)
            },
            isValidPassword(){
                return this.password != null
            },
            validatePassword(e) {
                this.isLoading = true;
                e.preventDefault()
                let carteira = {
                    "Data": this.dataText,
                    "Valor": this.formatReal(this.valueSaque),
                    "DadosBancarios": this.dadosBanco.DadosBancarios,
                    "InvestidorId": this.investor._id
                }

                console.log("CARTEIRA ->", carteira)

                let resposta = WalletService.CreateTransfer(carteira)
                .then(response => {
                    if (response.data.msg=== "SaldoInsuficiente"){
                        this.isLoading = false;
                        this.$Notify.error("Saldo total da carteira é insuficiente.");
                    }else{
                        this.$router.push(`/investimentos/carteira-investimento/`);
                    }
                    
                })
                .catch(error => {
                    if(this.tentativas < 3) {
                        console.error(`ERROR: ${error.message}`)
                        this.isLoading = false;
                        this.$Notify.error('Senha inválida!!! tente novamente');
                        this.tentativas++;
                    } else {
                        this.$store.dispatch('logout')
                        this.$router.push('/login')
                    }
                })
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/carteira-investimento/',
                    title: 'CarteiraInvestimento',
                })
            },
        },
        computed: {
            
            transferDate: {
                get: function() {
                    if(this.dateModel === null) {
                        let now = new Date()
                        let day = ("0" + now.getDate()).slice(-2);
                        let month = ("0" + (now.getMonth() + 1)).slice(-2);
                        let today = `${day}/${month}/${now.getFullYear()}`;

                        this.dateModel = today;
                    }

                    return this.dateModel;
                },

                set: function(newValue) {
                     this.dateModel = newValue
                }
            },
            valueSaqueDate: {
                get: function() {
                  return this.valueSaque;
                },
                set: function(newValue) {
                  this.valueSaque = newValue;
                }
            },
            User: function() {
                return this.$store.state.currentUser;
            }
        },
        async created() {

            await this.saldoAtualizado();

            await this.dadosBancarios(this.userId);

            // ApiClient.getMyAvalibleMoney()
            // .then(item => {

            //     item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            //     this.Credito =  parseFloat(item.data.credito) ;

            //     item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            //     this.Debito =  parseFloat(item.data.debito) ;

            // });

            ApiClient.getInfosMyInvestments()
            .then(infos => {
                var total = 0;
                this.Infos = infos;

                if(this.Infos.data != null && this.Infos.data.length > 0)
                this.renderizou = true;


                if(infos != null && infos != undefined && infos.data != undefined)
                {
                    this.Pendente = 0;

                    var solicitacoes  = Array();

                //this.Pendente
                    infos.data.forEach((item)=>{
                    if(item.Boleto == undefined || item.StatusBoleto == "expired" || ( item.Boleto != undefined && item.StatusBoleto == undefined))
                        this.Pendente+=item.Valor;
                        this.IdInvestidor = item.InvestidorId;
                    });

                //this.PorcentagemRetorno
                    var temp = 0.0, count = 0, somaValorNP= 0 ;

                    infos.data.forEach((item)=>{

                        if(item.SolicitacaoId != null && item.StatusBoleto == "paid")
                        {

                        if(item.SolicitacaoId.TipoEmprestimo != "emprestimo-de-impacto"){
                            temp += item.SolicitacaoId.RetornoBrutoMensal;
                            count++;
                        }
                        }
                    });

                    if(count > 0)
                        this.PorcentagemRetorno = (temp/count);
                    else
                        this.PorcentagemRetorno = 0;



                //this.Receber
                    var temp = 0.0, count = 0, somaValor= 0 ;
                    this.RendimentoTotal  = 0;


                    infos.data.forEach((item)=>{

                        if( item.SolicitacaoId != null && item.StatusBoleto == "paid"){


                            if(item.SolicitacaoId.RetornoBrutoMensal == undefined)
                            {
                                item.SolicitacaoId.RetornoBrutoMensal = 0;
                            }

                        var valorParcela = - this.PMT(item.SolicitacaoId.RetornoBrutoMensal / 100, item.SolicitacaoId.Prazo, item.Valor);

                        var with2Decimals = (item.SolicitacaoId.Prazo*valorParcela).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]


                        this.RendimentoTotal += parseFloat(with2Decimals)

                        total +=item.Valor;
                        }
                    });

                this.InvTotal = total;

            }
            }).catch(error => {
              console.log('error', error)
            })
            //tagueamento GA
            await this.taggingGA();
        },

        beforeCreate() {

            this.$store.commit(mutationTypes.START_LOADING)

            ApiClient.getInvestor()
            .then(response => {
                this.investor = response;

                console.log(this.investor)

                ApiClient.getWalletBank(this.investor.DadosBancarios.CodigoBanco)
                .then(response => {
                    this.bank = response.data;

                    this.bankRender = true
                })

                this.loading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
            .catch((error) => {
                console.log("request fail", error);
                this.loading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
        }
    }
</script>

<style scoped>
  #date {
    text-indent: 12px;
  }
  #date::-webkit-calendar-picker-indicator {
    display: none !important;
  }

  .field-container {
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/WalletFundsTransfer.vue